import { render } from "./filesend_popup.vue?vue&type=template&id=0b559be2&scoped=true"
import script from "./filesend_popup.js?vue&type=script&lang=js"
export * from "./filesend_popup.js?vue&type=script&lang=js"

import "./filesend_popup.vue?vue&type=style&index=0&id=0b559be2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b559be2"]])

export default __exports__